import { POST,postFile } from "../../index";

export const selectSim = (param) => POST("/v1/sim/selectSim", param);
export const insertSim = (param) => POST("/v1/sim/insertSim", param);
export const updateRemarks = (param) => POST("/v1/sim/updateRemarks", param);
export const importSim = (param) => postFile("/v1/sim/importSim", param);
export const abandonedSim = (param) => POST("/v1/sim/abandonedSim", param);
export const deleteSim = (param) => POST("/v1/sim/deleteSim", param);
